// The sidebar's Pages: the pages I pinned and the pages shared with me (monad/agent/pages.py), one read per mount.
// Plain state, not react-query: the sidebar renders outside any QueryClientProvider (see useInboxUnread). A pin,
// a re-share or an unpin in the chat pane refreshes it at once.
import { useEffect, useState } from 'react'
import type { PageSummary } from '@poiesis/agentArtifacts/types'
import { pagesApi } from '@/lib/artifact-api'

export interface PinnedPages { mine: PageSummary[]; shared: PageSummary[] }

const listeners = new Set<(p: PinnedPages) => void>()
let last: PinnedPages | null = null

export function refreshPinnedPages(): void {
  pagesApi.list().then((p) => { last = p; listeners.forEach((l) => l(p)) }).catch(() => {})
}

export function usePinnedPages(): PinnedPages | null {
  const [pages, setPages] = useState<PinnedPages | null>(last)
  useEffect(() => {
    listeners.add(setPages)
    refreshPinnedPages()
    return () => { listeners.delete(setPages) }
  }, [])
  return pages
}
